<div class="container-fluid" *ngIf="!summaryMode">
            <div class="form-check justify-content-start"
                 *ngFor="let option of options">
                <label class="form-check-label" for="answer_{{name}}_{{option}}">
                    <mat-checkbox 
                           name="answer_{{name}}_{{option}}"
                           [(ngModel)]="checkboxValue[option]"
                           (change)="onClick(option)"
                           id="answer_{{name}}_{{option}}"
                           [disabled]="showNoneOfTheAbove && noneOfTheAbove">
                    {{option}}</mat-checkbox>
                </label>
            </div>
            <div class="form-check justify-content-start" *ngIf="showNoneOfTheAbove">
                <label class="form-check-label" for="answer_{{name}}_none_of_the_above">
                    <mat-checkbox 
                           name="answer_{{name}}_none_of_the_above"
                           [(ngModel)]="noneOfTheAbove"
                           (change)="onNoneClick('noneOfTheAbove')"
                           id="answer_{{name}}_none_of_the_above"
                           [disabled]="noneOfTheAboveDisabled">
                           None of these apply to me</mat-checkbox>
                </label>
            </div>

    <mat-error *ngIf="question.invalid">required</mat-error>
</div>
<div class="container-fluid" *ngIf="summaryMode">
    <div class="row">
        <div class="col-12">
            <div class="form-check justify-content-start"
                 *ngFor="let option of options">
                <label class="form-check-label" for="answer_{{name}}_{{option}}">
                    <input type="checkbox" class="form-check-input"
                           name="answer_{{name}}_{{option}}"
                           [(ngModel)]="checkboxValue[option]"
                           disabled="noneOfTheAbove || summaryMode">
                    {{option}}
                </label>
            </div>
            <div class="form-check justify-content-start" *ngIf="showNoneOfTheAbove">
                <label class="form-check-label" for="answer_{{name}}_none_of_the_above">
                    <input type="checkbox" class="form-check-input"
                           name="answer_{{name}}_none_of_the_above"
                           [(ngModel)]="noneOfTheAbove"
                           disabled="(value != null && value.length > 0) || summaryMode">
                    None of these apply to me
                </label>
            </div>
        </div>
    </div>
</div>
